import { useState } from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { PostHeader } from '@/components/PostCard/components/PostHeader'
import { EditPostModal } from '@/components/EditPostModal'
import { TimelinePost } from '@/types/post'
import { RawCurationPost } from '@/types/curation'
import { usePostActions } from '@/hooks/use-post-actions'
import { convertRawCurationPostToTimelinePost } from '@/components/PostCard/utils'
import { usePostCardContext } from '@/components/PostCard/hooks/usePostCardContext'
import { usePostCardEdit } from '@/components/PostCard/hooks/usePostCardEdit'
import { PostCardContent } from '@/components/PostCard/components/PostCardContent'
import { PostCardActions } from '@/components/PostCard/components/PostCardActions'

export interface PostCardProps {
  post: TimelinePost | RawCurationPost
  status: 'pending' | 'approved' | 'rejected'
}

export function PostCard({ post, status }: PostCardProps) {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const timelinePost: TimelinePost = 'post_territory' in post 
    ? convertRawCurationPostToTimelinePost(post as RawCurationPost)
    : post as TimelinePost
  
  const actions = usePostActions(timelinePost)
  const { timelineContext, curationContext, isInCuration } = usePostCardContext()
  const { handleEditSuccess } = usePostCardEdit(post, timelinePost, timelineContext, curationContext)

  return (
    <Card className="border border-gray-200">
      <CardContent className="p-6">
        <div className="space-y-4">
          <PostHeader 
            status={status} 
            post={timelinePost} 
            actions={actions} 
            onEdit={() => setIsEditModalOpen(true)}
          />
          <PostCardContent post={timelinePost} status={status} />
          <PostCardActions 
            status={status} 
            actions={actions} 
            isInCuration={isInCuration}
            post={timelinePost}
          />
        </div>
      </CardContent>
      <EditPostModal
        open={isEditModalOpen}
        onOpenChange={setIsEditModalOpen}
        post={timelinePost}
        onSuccess={handleEditSuccess}
      />
    </Card>
  )
}
